export default "__VITE_ASSET__DEy1BL7V__"